export const LOAD_DATA = 'speakeasy/Dashboard/LOAD_DATA';

export const SET_INITIAL = 'speakeasy/Dashboard/SET_INITIAL';

export const SET_CAMPAIGN_DATA = 'speakeasy/Dashboard/SET_CAMPAIGN_DATA';

export const SET_RECIPIENT_DATA = 'speakeasy/Dashboard/SET_RECIPIENT_DATA';

export const GET_CAMPAIGN_DATA = 'speakeasy/Dashboard/GET_CAMPAIGN_DATA';
